module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/zl/gift/select_on.png";